export const SERVICE_CENTER_PERMISSIONS = {
  adminUpdateServiceCenterDetails: "adminUpdateServiceCenterDetails",
  adminGetServiceCenterDetails: "adminGetServiceCenterDetails",
  setEntitySettingInstance: "setEntitySettingInstance",
  adminCreateServiceCenterDetails: "AdminCreateServiceCenterDetails",
}